import { Link } from "react-router-dom";
import { useReveal } from "@/lib/useReveal";

const sectors = [
  {
    id: "workspaces",
    name: "Workspaces",
    note: "Headquarters, HQs and agile floors.",
    img: "/img/workspace.webp",
  },
  {
    id: "bars",
    name: "Bars",
    note: "Backbars, banquettes and considered detail.",
    img: "/img/bar.webp",
  },
  {
    id: "restaurants",
    name: "Restaurants",
    note: "From neighbourhood to fine dining.",
    img: "/img/restaurant.webp",
  },
  {
    id: "distilleries",
    name: "Distilleries",
    note: "Visitor experiences with provenance.",
    img: "/img/distillery.webp",
  },
  {
    id: "designed-interiors",
    name: "Designed Interiors",
    note: "Bespoke commissions for considered spaces.",
    img: "/img/designed.webp",
  },
];

export const Sectors = () => {
  const ref = useReveal();
  return (
    <section
      id="sectors"
      ref={ref}
      data-testid="sectors-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14 lg:mb-20">
          <div className="col-span-12 lg:col-span-3 reveal">
            <div className="overline">05 — Sectors</div>
          </div>
          <div className="col-span-12 lg:col-span-9 reveal">
            <h2
              data-testid="sectors-heading"
              className="font-display text-3xl sm:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1.02]"
            >
              Built for spaces that <span className="italic text-black/55">have to feel right.</span>
            </h2>
          </div>
        </div>

        <ul className="border-t hairline reveal">
          {sectors.map((s, i) => (
            <li
              key={s.id}
              data-testid={`sector-${s.id}`}
              className="group relative border-b hairline"
            >
              <Link
                to={`/sectors/${s.id}`}
                className="grid grid-cols-12 gap-6 items-center px-2 lg:px-6 py-7 lg:py-10 transition-colors hover:bg-[#0A0A0A] hover:text-white"
              >
                <div className="col-span-2 lg:col-span-1 font-display text-2xl lg:text-3xl text-black/40 group-hover:text-white/55">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="col-span-7 lg:col-span-6 font-display text-2xl sm:text-3xl lg:text-5xl tracking-tight">
                  {s.name}
                </div>
                <div className="col-span-3 lg:col-span-3 text-xs lg:text-sm opacity-70">
                  {s.note}
                </div>
                <div className="hidden lg:block col-span-2">
                  <div className="ml-auto w-28 h-20 overflow-hidden">
                    <img
                      src={s.img.replace(".webp", "-sm.webp")}
                      alt={s.name}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                    />
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Sectors;
